import { Button, Col, Icon, Input, Row } from 'antd';
import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';


type PropType = {
    type: string;
    className?: string;
    name: string;
    nameComp?: string;
    label?: string;
    items?: any;
    placeholder?: string;
    value?: any;
    valueBtn?: any;
    withError?: boolean;
    disabled?: boolean;
    addorn?: any;
    setFieldValue: Function;
    setTouched: Function;
    onFocus: Function;
    onBlur: Function;
    form: any;
};


type StateType = {
    isLoading: boolean;
    name: string;
    shareholders?: any[];
    extraFields?: any[];
    showFormModal: boolean;
    type: string;
    numberField: number;
    showingAdvancedOptions: boolean;

};

class ListField extends React.Component<PropType, StateType> {


    constructor(props: any) {
        super(props);
    }


    state = {
        isLoading: true,
        showFormModal: false,
        type: '',
        name: '',
        shareholders: [this.props.name],
        numberField: 1,
        Inputs: [],
        extraFields: [],
        showingAdvancedOptions: false,

    };

    setAdvanced(newValue: boolean) {
        this.setState({ showingAdvancedOptions: newValue });
    }


    handleNameChange = (evt: any) => {
        this.setState({ name: evt.target.value });
    }

    handleValueChange = (evt: any) => {
        this.setState({ type: evt.target.value });
    }

    setFieldValue = (idx: any) => (evt: any) => {
        const newShareholders = this.state.shareholders.map((shareholder, sidx) => {
            if (idx !== sidx) return shareholder;
            return this.props.name, evt.target.value;
        });

        this.setState({ shareholders: newShareholders });

    }


    handleAddShareholder = async () => {
        this.setState({
            shareholders: this.state.shareholders.concat([this.props.name]),
        });

    }

    handleRemoveShareholder = (idx: any) => async () => {

        this.setState({
            shareholders: this.state.shareholders.filter((s, sidx) => idx !== sidx),
            // numberField: this.state.numberField - 1
        });

    }


    render() {
        const {
            showingAdvancedOptions,
        } = this.state;



        return (
            <AppContext.Consumer>
                {({ locale, theme }) => (
                    <InputWrapper>
                        <br />

                        <div>


                            <Row>
                                <Col sm={14} md={14} xl={14}>
                                    <span >{I18n.l('form.taskflowschedule.labels.matrizline')}</span>

                                </Col>
                                <Col sm={10} md={10} xl={10}>
                                    <span>{I18n.l('form.taskflowschedule.labels.matrizvalue')}</span>

                                </Col>
                            </Row>
                        </div>

                        <form >

                            {(this.state.shareholders) &&
                                (this.state.shareholders.map((x: any, idx) => (

                                    <div className="shareholder" >
                                        <div>
                                            <Row>

                                                <Input
                                                    style={{ width: '50%' }}
                                                    type={this.props.type}
                                                    name={this.props.name}
                                                    onChange={(e: any) => {
                                                        this.props.setFieldValue(this.props.name, e.target.value, idx);
                                                        this.props.setTouched({ [this.props.name]: true });
                                                    }}
                                                />
                                                <Input
                                                    style={{ width: '30%', marginLeft: '10px' }}
                                                    type={this.props.type}
                                                    name={this.props.nameComp}
                                                    onChange={(e: any) => {
                                                        this.props.setFieldValue(this.props.nameComp, e.target.value, idx);
                                                        this.props.setTouched({ [this.props.name]: true });
                                                    }}
                                                />

                                                {
                                                    idx >= 0 ? (
                                                        <Icon
                                                            style={{ color: 'red', marginLeft: '10px' }}
                                                            className="dynamic-delete-button"
                                                            type="close"
                                                            // disabled={x.lenght === 1}
                                                            onClick={this.handleRemoveShareholder(idx)}
                                                        />
                                                    ) : null
                                                }

                                            </Row>
                                        </div>
                                    </div>

                                )))}

                            <Button style={{ marginTop: '10px', marginBottom: '15px' }} type="dashed" onClick={this.handleAddShareholder}>
                                <Icon type="plus" /> {I18n.l('users.addfield')}
                            </Button>
                        </form>



                    </InputWrapper>
                )}
            </AppContext.Consumer>

        );
    }
}

const InputWrapper = styled.div`
  
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }

  
`;

const ButtonStyle = styled.div`
flex-flow: row nowrap;
align-items: center;
justify-content: space-between;
${({ theme }) => get(theme, 'form.inputWrapper')};

&.search {
  ${({ theme }) => get(theme, 'form.searchWrapper')};
}
&.auth-style {
  ${({ theme }) => get(theme, 'form.authWrapper')};
}
button {
    
    border-radius: 0;
    

    &:first-of-type {
      border-radius: 10px 0 0 10px;
       
    }
    &:last-of-type {
      border-radius: 0 10px 10px 0;
    }

    

  }
`;
// const Input = styled.input`
//   background: #fff;
//   flex: 1;
//   ${({ theme }) => get(theme, 'form.input')};

//   &.search {
//     ${({ theme }) => get(theme, 'form.search')};
//   }
//   &.auth-style {
//     ${({ theme }) => get(theme, 'form.auth')};
//   }
// `;

export default ListField;
